import { Injectable } from '@angular/core';
import { Observable, of, ReplaySubject, timer } from 'rxjs';
import { distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { LoginException } from '../types/login-exception';

@Injectable()
export class LoginExceptionService {

    private exception: ReplaySubject<LoginException>;

    constructor() {
        this.exception = new ReplaySubject<LoginException>(1);
    }

    setException(exception: LoginException): void {
        this.exception.next(exception);
    }

    getCurrentException(): Observable<LoginException> {
        return this.exception.asObservable()
            .pipe(
                switchMap(exception => {
                    if (!exception) {
                        return of(null);
                    }

                    return timer(10000)
                        .pipe(
                            map(() => {

                                this.setException(null);
                                return null;
                            }),
                            startWith(exception)
                        );
                }),
                distinctUntilChanged()
            );
    }
}
